import React from 'react'

const AccessPage = () => (
<div className='access'>
  <h2>アクセスマップ</h2>
  <ul className="breadcrumb">
    <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
    <a href="/" itemProp="url">
      <span itemProp="title"><i className="fas fa-home"></i> ホーム</span>
    </a>
    </li>
    <li itemScope="itemscope" itemType="http://data-vocabulary.org/Breadcrumb">
      <span itemProp="title"> <i className="fas fa-caret-right"></i> アクセスマップ</span>
    </li>
  </ul>
  <p className='description'>JR横浜線『淵野辺』南口より徒歩17分</p>
  <p className='address'>所在地：神奈川県相模原市中央区弥栄1-11-5-1</p>
  <iframe className='map' title='アクセスマップ' src='https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d6491.136701955664!2d139.38695217611075!3d35.56436127088679!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e2!4m5!1s0x6018fda608cb1be3%3A0xd3975aad7652c17f!2z44CSMjUyLTAyMDYg56We5aWI5bed55yM55u45qih5Y6f5biC5Lit5aSu5Yy65re16YeO6L6677yT5LiB55uu77yVIOa3temHjui-uumnhQ!3m2!1d35.568739799999996!2d139.3950611!4m5!1s0x6018fdbd21658ab7%3A0xef26eafcdf1c786f!2z44CSMjUyLTAyMjkg56We5aWI5bed55yM55u45qih5Y6f5biC5Lit5aSu5Yy65byl5qCE77yR5LiB55uu77yR77yR4oiS77yV!3m2!1d35.5600447!2d139.38790699999998!5e0!3m2!1sja!2sjp!4v1648276195085!5m2!1sja!2sjp' width='600' height='450' allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade">
  </iframe>
  <div className='spots'>
    <h3 className='title'>周辺情報</h3>
    <div className='updateTime'>2022年2月現在</div>
    <table>
      <thead>
        <tr>
          <th scope='col'>名称</th>
          <th scope='col'>物件からの距離</th>
          <th scope='col'>備考</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className='name'>スーパー三和 並木店</td>
          <td className='distance'>徒歩5分</td>
          <td className='note'></td>
        </tr>
        <tr>
          <td className='name'>セブンイレブン・ローソン</td>
          <td className='distance'>徒歩5分</td>
          <td className='note'></td>
        </tr>
        <tr>
          <td className='name'>セリア相模原店</td>
          <td className='distance'>徒歩10分</td>
          <td className='note'><a href='https://www.seria-group.com/shop/detail.html?code=000000405'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>サンドラッグ 相模原並木店</td>
          <td className='distance'>徒歩11分</td>
          <td className='note'><a href='https://www.e-map.ne.jp/p/sundrug/dtl/0218/?&his=cb,nm&srchplace=35.5562361,139.3829194&pexkid=0218'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>文教堂書店 星ヶ丘店</td>
          <td className='distance'>徒歩15分</td>
          <td className='note'><a href='https://www.bunkyodo.co.jp/page-detail-store/?id=181'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>コジマ×ビックカメラ 相模原店</td>
          <td className='distance'>徒歩12分</td>
          <td className='note'><a href='https://www.kojima.net/shop/shoplist/sagamihara.html'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>相模原市立図書館</td>
          <td className='distance'>徒歩16分</td>
          <td className='note'><a href='https://www.lib.sagamihara.kanagawa.jp/TOSHOW/asp/library_01.aspx'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>相模原市立淵野辺公園</td>
          <td className='distance'>徒歩10分</td>
          <td className='note'><a href='https://www.sagamiharashi-machimidori.or.jp/ginga_arena'>公式サイト</a>テニスコート12面 1,300円/2H（夜間照明料：600円）、卓球3H390円、プール兼スケート場、ジム1回400円</td>
        </tr>
        <tr>
          <td className='name'>コロッケ倶楽部 相模原店</td>
          <td className='distance'>徒歩11分</td>
          <td className='note'>平日 昼(10:00～19:00)の一般料金328円/H。<a href='http://www.korokke.com/shop/shousai.php?no=OTg='>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>大野北公民館</td>
          <td className='distance'>徒歩17分</td>
          <td className='note'><a href='http://www.sagamihara-kng.ed.jp/kouminkan/onokita-k/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>JAXA 宇宙科学研究所 相模原キャンパス</td>
          <td className='distance'>徒歩8分</td>
          <td className='note'><a href='https://www.jaxa.jp/about/centers/sagamihara/index_j.html'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>相模原弥栄郵便局</td>
          <td className='distance'>徒歩4分</td>
          <td className='note'></td>
        </tr>
        <tr>
          <td className='name'>相模原市立弥栄小学校</td>
          <td className='distance'>徒歩3分</td>
          <td className='note'><a href='http://www.sagamihara-yaei-e.ed.jp/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>相模原市立弥栄中学校</td>
          <td className='distance'>徒歩5分</td>
          <td className='note'><a href='http://www.sagamihara-yaei-j.ed.jp/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>神奈川県立相模原弥栄高等学校</td>
          <td className='distance'>徒歩6分</td>
          <td className='note'><a href='https://www.pen-kanagawa.ed.jp/sagamiharayaei-h/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>相生保育園</td>
          <td className='distance'>徒歩5分</td>
          <td className='note'><a href='https://www.tf-kai.jp/aioi/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>並木湯</td>
          <td className='distance'>徒歩11分</td>
          <td className='note'>2017年に日本列島を襲った台風の影響で煙突が倒壊してしまいましたが、2ヶ月後に営業再開しました。番頭さんのおばちゃんのお人柄や安心できる空間が地元住民から愛される銭湯です。大人470円、小人200円。<a href="https://yukatsu.hatenablog.com/entry/2022/01/04/%E4%B8%A6%E6%9C%A8%E6%B9%AF%EF%BD%9C%E6%B7%B5%E9%87%8E%E8%BE%BA%EF%BD%9C%E6%B9%AF%E6%B4%BB%E3%83%AC%E3%83%9D%E3%83%BC%E3%83%88%EF%BC%88%E9%8A%AD%E6%B9%AF%E7%B7%A8%EF%BC%89vol678">紹介サイト</a></td>
        </tr>
        <tr>
          <td className='name'>淵野辺総合病院</td>
          <td className='distance'>徒歩24分</td>
          <td className='note'><a href='http://www.sowa.or.jp/fuchinobe/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>グルメシティ光が丘店</td>
          <td className='distance'>徒歩17分</td>
          <td className='note'>24時間営業。年中ほぼ無休。<a href='https://www.daiei.co.jp/stores/d0540/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>ローソン・スリーエフ 相模原富士見町店</td>
          <td className='distance'>徒歩15分</td>
          <td className='note'>24時間営業。文教堂書店併設。<a href='https://www.google.com/search?q=%E3%82%B3%E3%83%B3%E3%83%93%E3%83%8B%20%E6%9C%AC%E5%B1%8B%20%E7%9B%B8%E6%A8%A1%E5%8E%9F&sxsrf=APq-WBsihdRfW7PB08GGkAm2QIupM_U_bQ:1650215300026&ei=WklcYsS5BYbN-QbvhLPQAg&ved=2ahUKEwj094qGy5v3AhWQAYgKHYSfD-oQvS56BAgFEAE&uact=5&oq=%E3%82%B3%E3%83%B3%E3%83%93%E3%83%8B+%E6%9C%AC%E5%B1%8B+%E7%9B%B8%E6%A8%A1%E5%8E%9F&gs_lcp=Cgdnd3Mtd2l6EAMyBggAEAgQHjoECCMQJzoFCAAQsQM6CAgAELEDEIMBOgkIABCABBAEECU6DwgAEIAEELEDELEDEAQQJToVCAAQgAQQsQMQgwEQsQMQgwEQBBAlOgQIABBDOggIABCABBCxAzoECAAQAzoLCAAQgAQQsQMQgwE6BwgjEOoCECc6CggAEIAEELEDEAQ6BggAEAQQAzoHCAAQgAQQBDoHCAAQsQMQQzoQCAAQsQMQgwEQsQMQgwEQQzoNCAAQgAQQsQMQgwEQBDoNCAAQgAQQsQMQsQMQBDoGCAAQBBAeOggIABAEEAoQHjoECAAQHjoFCAAQgAQ6BQghEKABOggIABAIEAQQHjoKCAAQCBAEEAoQHkoECEEYAUoECEYYAFD-HFjOjwFgu5MBaA1wAHgAgAGQA4gBrTeSAQo0LjQzLjQuMC4xmAEAoAEBsAEKwAEB&sclient=gws-wiz&tbs=lf:1,lf_ui:3&tbm=lcl&rflfq=1&num=10&rldimm=4193205819237067358&lqi=Ch3jgrPjg7Pjg5Pjg4sg5pys5bGLIOebuOaooeWOn1olIh3jgrPjg7Pjg5Pjg4sg5pys5bGLIOebuOaooeWOnyoECAMQAJIBEWNvbnZlbmllbmNlX3N0b3JlmgEjQ2haRFNVaE5NRzluUzBWSlEwRm5TVU5MZGs1Mk9VeFJFQUWqARsQASoXIhPjgrPjg7Pjg5Pjg4sg5pys5bGLKAg&sa=X&rlst=f#rlfi=hd:;si:4193205819237067358,l,Ch3jgrPjg7Pjg5Pjg4sg5pys5bGLIOebuOaooeWOn1olIh3jgrPjg7Pjg5Pjg4sg5pys5bGLIOebuOaooeWOnyoECAMQAJIBEWNvbnZlbmllbmNlX3N0b3JlmgEjQ2haRFNVaE5NRzluUzBWSlEwRm5TVU5MZGs1Mk9VeFJFQUWqARsQASoXIhPjgrPjg7Pjg5Pjg4sg5pys5bGLKAg;mv:[[35.584558099999995,139.4272564],[35.524420299999996,139.2530791]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:3'>マップ</a></td>
        </tr>
        <tr>
          <td className='name'>ベジたべーな</td>
          <td className='distance'>徒歩18分</td>
          <td className='note'>相模原市産の採れたて新鮮野菜が販売されています。<a href='https://www.sagamegu.com/archives/269'>紹介サイト</a></td>
        </tr>
        <tr>
          <td className='name'>リサイクルガーデン</td>
          <td className='distance'>徒歩23分</td>
          <td className='note'>メディアへの露出も多数。地域最大級のリサイクルショップ。日用品もあり、10円、88円均一が人気。<a href='http://recycle-garden.net/shop/sagamihara/'>公式サイト</a></td>
        </tr>
        <tr>
          <td className='name'>国際交流ラウンジ</td>
          <td className='distance'>徒歩18分</td>
          <td className='note'>外国人市民が日本語を学ぶことができる日本語教室、 外国人市民のための通訳・翻訳・相談、世界の国々の文化に触れ合う催しなどが行われています。週末など、日本人ボランティアも募集しています。<a href='https://www.sagamihara-international.jp/'>公式サイト</a></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
)

export default AccessPage


// WEBPACK FOOTER //
// ./src/AccessPage.js